import React from 'react';

import {AnalysisMainViewItemType, MainViewComponentProps} from 'analysis-tool/ui/main-view/MainViewTypes';

import AnalysisFlowchart from './AnalysisFlowchart';

type AnalysisFlowchartViewProps = Pick<
  MainViewComponentProps<AnalysisMainViewItemType.FLOWCHART>,
  'analysis'
>;

/**
 * A flowchart representation of an analysis, as rendered full-screen in the analysis tool.
 */
export default function AnalysisFlowchartView({analysis}: AnalysisFlowchartViewProps): JSX.Element {
  return <AnalysisFlowchart analysis={analysis} />;
}
